const loadQueue = []
let loadingPromise = null

export default {
  store: {

    state: {
      loaded: true,
      postLoad: [],
    },

    actions: {
      /*
        Sets state.loaded = true, after given loader Promise
        is resolved.
      */
      LOAD({ state, commit }, loader) {
        if (loader) loadQueue.push(loader)

        const executeNext = () => {
          if (!loadQueue.length) {
            commit('SET_LOADED', true)
            // dispatch('EXEC_LOADED')
            return Promise.resolve()
          }

          const task = loadQueue.slice(0, 1)[0]
          loadingPromise = task()
            .then(() => {
              if (loadQueue.length) loadQueue.splice(0, 1)

              return Promise.resolve()
            }, () => {
              // Never leave the queue wedged: a single rejected fetch
              // (e.g. a timed-out FIND on a large account) must not keep
              // `loaded === false` forever, which renders an infinite
              // loader. The error itself is already reported via the
              // store ERROR handler, so drop the failed task and continue.
              if (loadQueue.length) loadQueue.splice(0, 1)

              return Promise.resolve()
            })
            .then(executeNext)

          return loadingPromise
        }

        if (!loadQueue.length) return Promise.resolve()

        if (state.loaded) {
          commit('SET_LOADED', false)
          return executeNext()
        }

        return loadingPromise
      },
    },

    mutations: {
      SET_LOADED(state, value) {
        state.loaded = value
      },
    },

    getters: {
      loaded: state => state.loaded,
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/load.js